import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { BankAccount } from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { BankAccountTableRow } from "./row";
import { BANK_ACCOUNT_TABLE_COLUMNS } from "../../../../../constants";

interface Props {
  bankAccounts: BankAccount[];
  messages: T2PayHomeMessages;
  onRemove: (account: BankAccount) => void;
  handleOpen: (selected?: unknown) => void;
  data: PaginatedResponse<BankAccount>;
  pagination: Pagination;
}

export function BankAccountTable({
  bankAccounts,
  messages,
  data,
  pagination,
  onRemove,
  handleOpen,
}: Props) {
  const columns = BANK_ACCOUNT_TABLE_COLUMNS(messages);

  return (
    <MDBox width="100%" textAlign="center" mx="auto">
      <MDBox display="flex" justifyContent="space-between" alignItems={"center"}>
        <MDBox />

        <MDButton
          variant="gradient"
          color="dark"
          endIcon={<AddCircleOutlineIcon />}
          onClick={() => handleOpen()}
        >
          {messages.submitButtonLabel}
        </MDButton>
      </MDBox>

      <MDBox mt={1}>
        <Grid container spacing={3}>
          <TableContainer sx={{ marginTop: 1 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableHeaderRow>
                  {columns.map((label, index) => (
                    <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
                  ))}
                </TableHeaderRow>
              </TableHead>

              <TableBody>
                {bankAccounts && bankAccounts.length <= 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <MDTypography variant="h6" color="text" fontWeight={"regular"}>
                        {messages.errorMessage}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                ) : (
                  bankAccounts &&
                  bankAccounts.map((singleAccount, index) => (
                    <BankAccountTableRow
                      key={`${index} - ${singleAccount.accountNumber}`}
                      account={singleAccount}
                      index={index}
                      messages={messages}
                      onRemove={onRemove}
                      openDialog={handleOpen}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            labelRowsPerPage={messages.rowsPerPage}
            rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
            component="div"
            count={data.totalCount}
            onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
            rowsPerPage={pagination.pageSize}
            page={pagination.pageNumber - 1}
            onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
          />
        </Grid>
      </MDBox>
    </MDBox>
  );
}
